/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_No_OrdersInputs */

const vi_trip_no_orders = /** @type {(inputs: Trip_No_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyến chưa có đơn`)
};

/**

* @param {Trip_No_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_no_orders = /** @type {((inputs?: Trip_No_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_No_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_no_orders(inputs)
});